import { getPublicIp } from "../../services";
import type { Authenticity } from "../../services/APIService/types";
import { LOCAL_STORAGE_SESSION_ID } from "../../constants";

// Acesso ao objeto de autenticidade
export const getAuthenticity = async (): Promise<Authenticity> => {
	const ip = await getPublicIp();
	const hashID = localStorage.getItem(LOCAL_STORAGE_SESSION_ID);

	return {
		fingerprint: hashID || "",
		ipAddress: ip,
		sessionId: hashID || "",
		timestamp: new Date().toISOString(),
	};
};
